export const ugovor_o_zajmu_zajmoprimac_fizicka_osoba = {
    templateId: 47,
    category: 5,
    templateTitle: "Ugovor o zajmu (novčanom) - zajam prima fizička osoba",
    templateDescription: `<p>Ugovorom o zajmu obvezuje se zajmodavac predati zajmoprimcu određeni iznos/količinu zamjenljivih stvari (najčešće novca), a zajmoprimac se obvezuje vratiti mu poslije stanovitog vremena isti iznos novca, odnosno istu količinu stvari iste vrste i kakvoće.</p>`,
    description: `
    <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>
    <p>Ugovorom o zajmu obvezuje se zajmodavac predati zajmoprimcu određeni iznos novca ili određenu količinu drugih zamjenljivih stvari, a zajmoprimac se obvezuje vratiti mu poslije stanovitog vremena isti iznos novca, odnosno istu količinu stvari iste vrste i kakvoće.</p>
    <p>Ovim tekstom te dolje navedenim primjerom uređuje se novčani zajam koje poduzetnici daju fizičkim osobama.</p>
    <p>Kamate povoljnije od 2% godišnje koje poduzetnici obračunavaju fizičkim osobama po osnovi danog zajma, smatraju se primitkom u naravi sukladno Zakonu o porezu na dohodak.</p>
    <p>Primitkom po osnovi povoljnijih kamata smatra se razlika između ugovorene niže i stope kamate od 2% godišnje, osim kamata po kreditima koji se daju ili subvencioniraju iz proračuna, ali ne radnicima uprave.</p>
    <p>Ako se takav zajam daje:</p>
    <p>- dioničaru ili članu društva (vlasniku/ suvlasniku) - beskamatni zajam ili povoljnija kamata (manja od 2%) smatra se dohotkom od kapitala po osnovi skrivene isplate dobiti i oporezuje se po stopi od porezom i prirezom,</p>
    <p>- radniku - beskamatni zajam ili povoljnija kamata (manja od 2%) smatra se plaćom u naravi i obračunati sva propisana davanja kao i na redovnu plaću,</p>
    <p>- drugim fizičkim osobama - beskamatni zajam ili povoljnija kamata (manja od 2%) smatra primitkom na koji se utvrđuje drugi dohodak.</p>
    <p>Dakle, kod davanja zajmova fizičkim osobama, najuputnije je ugovoriti kamate u visini 2% godišnje (ili više) te tada ne postoji obveza utvrđivanja oporezivih primitaka fizičke osobe.</p>
    <p>Pravna osoba će po osnovi obračunatih kamata iskazati prihode od kamata.</p>
    <p>U slučaju da je fizička osoba, bilo zajmodavac, bilo zajmoprimac, kamata ne može biti viša od stope zakonskih zateznih kamata uvećih za polovinu te stope.</p>
    <p>Stopa zakonskih zateznih kamata za odnose u kojima je fizička osoba, bilo zajmodavac, bilo zajmoprimac, određuje se uvećanjem prosječne kamatne stope na stanje kredita odobrenih na razdoblje od godine dana nefinancijskih trgovačkim društvima izračunate za referentno razdoblje koje prethodi tekućem razdoblju za tri postotna poena.</p>
    <p>Prosječna kamatna stopa na stanje kredita odobrenih na razdoblje dulje od godine dana nefinancijskim trgovačkim društvima primjenjiva na prvo polugodište 2022. godine iznosi 2,49%.</p>   
    <p>Uvećanjem navedene stope za 3%-tna poena dobijemo stopu zakonske zatezne kamate na ovaj odnos od 5,49%, a najveća dopuštena ugovorna kamata je kako je navedeno veća za polovinu te stope čime dobivamo da je najveća dopuštena ugovorna kamatna stopa primjenjiva na odnose u kojima je fizička osoba davatelj zajma -<strong>8,24%</strong>.</p>
    <p>Na kamate i zatezne kamate ne obračunava se PDV.</p>
    <h5><strong>PRAVNA OSNOVA</strong></h5>
    <p>Zakon o obveznim odnosima, Zakon o porezu na dohodak, Pravilnik o porezu na dohodak.</p>
  `,

    sides: [
        {
            signature: 'Zajmodavac:',
            inputs: [{
                type: "input",
                required: true,
                placeholder: "Poslovni subjekt",
              },
              {
                type: "input",
                required: true,
                placeholder: "Ulica i kućni broj",
              },
              {
                type: "input",
                required: true,
                placeholder: "Mjesto",
              },
              {
                type: "input",
                required: true,
                placeholder: "OIB",
              },
              {
                type: "input",
                mandatory: false,
                editable: true,
                placeholder: "Zastupa (za pr. osobe)",
                inSignature: true,
              },
              {
                type: "input",
                placeholder: "Funkcija (za pr. osobe)",
                inSignature: true,
              }],
            suffix: ' (u daljnjem tekstu: Zajmodavac)',
            delimiter: `i`
        },
        {
            signature: 'Zajmoprimac:',
            inputs: [{
                type: 'input',
                required: true,
                placeholder: 'Ime i prezime',
                inSignature: true,
            },
                {
                    type: 'input',
                    required: true,
                    placeholder: 'Ulica i kućni broj',
                },
                {
                    type: 'input',
                    required: true,
                    placeholder: 'Mjesto',
                },
                {
                    type: 'input',
                    required: true,
                    placeholder: 'OIB',
                },
            ],
            suffix: ' (u daljnjem tekstu: Zajmoprimac),'
        }
    ],

    headline: 'zaključuju sljedeći',
    title: 'UGOVOR ZAJMU',
    noArticleNumbers: false,

    articles: [
        {
            title: 'IZNOS ZAJMA',
            mandatory: true,
            editable: false,
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    parts: [
                        {type: 'text', content: 'Zajmodavac daje Zajmoprimcu zajam u iznosu od'},
                        {type: 'input', value: '', required: true,},
                        {
                            type: 'text',
                            content: ', a Zajmoprimac se obvezuje vratiti Zajmodavcu iznos zajma prema odredbama ovog Ugovora.'
                        }],
                }],
            value: '',
        },
        {
            title: 'UPLATA ZAJMA',
            mandatory: true,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    editable: false,
                    choices: [
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Zajmodavac će iznos Zajma uplatiti na račun Zajmoprimca, IBAN broj:'
                                },
                                {type: 'input', value: '', required: true,},
                                {
                                    type: 'text',
                                    content: ', otvoren kod'
                                },
                                {type: 'input', value: '', required: true,},
                                {type: 'text', content: 'd.d.,'},
                                {help: 'Upišite naziv banke u kojoj Zajmoprimac ima otvoren račun.'},
                                {type: 'text', content: 'odmah prilikom potpisa ovog Ugovora.'}]
                        },
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Zajmodavac će iznos Zajma uplatiti na račun Zajmoprimca, IBAN broj:'
                                },
                                {type: 'input', value: '', required: true,},
                                {
                                    type: 'text',
                                    content: ', otvoren kod'
                                },
                                {type: 'input', value: '', required: true,},
                                {type: 'text', content: 'd.d.,'},
                                {help: 'Upišite naziv banke u kojoj Zajmoprimac ima otvoren račun.'},
                                {type: 'text', content: 'u roku od'},
                                {type: 'input', value: '', required: true,},
                                {type: 'text', content: 'dana od dana potpisa ovog Ugovora.'}]
                        },
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Zajmodavac će iznos Zajma predati Zajmoprimcu u gotovini, u roku od'
                                },
                                {type: 'input', value: '', required: true,},
                                {
                                    type: 'text',
                                    content: 'dana od dana potpisa ovog Ugovora, a što će Zajmoprimac potvrditi svojim potpisom.',
                                    help: 'Prema Zakonu o sprječavanju pranja novca i financiranju terorizma, pravna ili fizička osoba koja obavlja registriranu djelatnost u Republici Hrvatskoj ne smije primiti naplatu ili obaviti plaćanje u gotovini u vrijednosti od 75.000,00 kuna na više. Navedena naplata ili plaćanje u gotovini, mora se provesti uplatom ili prijenosom na transakcijski račun.'
                                }]
                        },
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Zajmodavac je iznos zajma predao Zajmoprimcu prilikom potpisa ovog Ugovora u gotovini, a što Zajmoprimac potvrđuje potpisom ovog Ugovora.',
                                    help: 'Prema Zakonu o sprječavanju pranja novca i financiranju terorizma, pravna ili fizička osoba koja obavlja registriranu djelatnost u Republici Hrvatskoj ne smije primiti naplatu ili obaviti plaćanje u gotovini u vrijednosti od 75.000,00 kuna na više. Navedena naplata ili plaćanje u gotovini, mora se provesti uplatom ili prijenosom na transakcijski račun.'
                                }]
                        }],
                    value: '',
                }
            ]
        },
        {
            title: 'KAMATE',
            mandatory: true,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    editable: false,
                    choices: [
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Zajmodavac daje Zajmoprimcu zajam iz ovog Ugovora beskamatno.',
                                    help: 'Prije odabir ovog izbora (zajam bez kamata) molimo pažljivo pročitajte uvodni tekst gore.'
                                }]
                        },
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Zajmodavac daje Zajmoprimcu zajam iz ovog Ugovora uz kamatnu stopu od'
                                },
                                {type: 'input', value: '', required: true,},
                                {
                                    type: 'text',
                                    content: ' % (posto) godišnje.',
                                    help: 'Za najvišu dopuštena kamatna stopa u ovom slučaju, molimo pročitajte tekst gore.'
                                }]
                        }],
                    value: '',
                }
            ]
        },
        {
            title: 'OBRAČUN KAMATA',
            mandatory: false,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    editable: false,
                    choices: [
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Kamate se obračunavaju mjesečno, a obračun kamata dospijeva na naplatu do'
                                },
                                {type: 'input', value: '', required: true},
                                {
                                    type: 'text',
                                    content: '-og u mjesecu za prethodni mjesec.',
                                    help: 'Ovaj članak je sastavni dio ugovora isključivo ukoliko se zajam daje uz kamatu.'
                                },
                            ]
                        },
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Kamate se obračunavaju pri povratu zajma, a obračun kamata dospijeva na naplatu povratom cjelokupnog iznosa zajma.',
                                    help: 'Ovaj članak je sastavni dio ugovora isključivo ukoliko se zajam daje uz kamatu.'
                                }
                            ]
                        }
                    ],
                    value: '',
                }
            ]
        },
        {
            title: 'ROK VRAĆANJA ZAJMA',
            mandatory: true,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    editable: false,
                    choices: [
                        {
                            parts: [
                                {type: 'text', content: 'Zajmoprimac se obvezuje Zajmodavcu vratiti zajam jednokratno, najkasnije do'},
                                {type: 'input', value: '', required: true},
                                {type: 'text', content: 'godine.'},
                            ]
                        },
                        {
                            parts: [
                              { type: "text", content: "Zajmoprimac se obvezuje Zajmodavcu vratiti zajam u sljedećim ratama i iznosima: " },
                              {type: "textarea", value: "", required: true },
                              { help: 'Ovdje samostalno i po vlastitoj volji upisujete iznose rata i rokove dospijeća svake pojedine rate.'}
                            ]
                          }
                        ],
                        value: "",
                      },
                    ]
                  },
                  {
                      
                    title: 'RANIJI POVRAT ZAJMA',
                    mandatory: false,
                    statements: [
                        {
                            type: 'choice',
                            mandatory: true,
                            editable: true,
                            choices: [
                                'Zajmoprimac može zajam iz ovog Ugovora vratiti i prije roka određenog za vraćanje zajma. \r\nU slučaju prijevremenog vraćanja, Zajmoprimac je isti dužan najaviti 30 dana ranije.',
                                'Zajam iz ovog Ugovora nije moguće vratiti prije roka određenog za vraćanje.'
                              ],
                              placeholder: "Odaberite ovdje te potom izmijenite po želji...",
                        }
                    ]
                },
                {
                    title: 'ZATEZNE KAMATE',
                    mandatory: false,
                    editable: true,
                    statements: [
                        {
                            type: 'text',
                            required: false,
                            mandatory: true,
                            editable: true,
                            content: 'Ukoliko Zajmoprimac dospjele obveze iz ovog Ugovora ne podmiri u roku dospijeća, obvezan je na dospjele i nenaplaćene iznose platiti zateznu kamatu koja se obračunava u visini zakonske zatezne kamate.',
                            help: 'Za iznos zakonske zatezne kamate molimo pročitajte tekst gore.'
                        }
                       ],
                    value: '',
                },
        {
            title: 'SREDSTVA OSIGURANJA VRAĆANJA ZAJMA ',
            mandatory: false,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    editable: false,
                    choices: [
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Zajmoprimac kao sredstvo osiguranja vraćanja zajma iz ovog Ugovora predaje Zajmodavcu bjanko zadužnicu na iznos do'
                                },
                                {type: 'input', value: '', required: true},
                                {
                                    type: 'text',
                                    content: 'kn, potvrđenu po javnom bilježniku, uz međusobni potpis zapisnika o primopredaji sredstava osiguranja.'
                                }]
                        },
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Zajmoprimac kao sredstvo osiguranja vraćanja zajma iz ovog Ugovora predaje Zajmodavcu običnu zadužnicu na iznos'
                                },
                                {type: 'input', value: '', required: true},
                                {
                                    type: 'text',
                                    content: 'kn, potvrđenu po javnom bilježniku, uz međusobni potpis zapisnika o primopredaji sredstava osiguranja.'
                                }]
                        },
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Zajmoprimac kao sredstvo osiguranja vraćanja zajma iz ovog Ugovora predaje Zajmodavcu vlastitu trasiranu mjenicu bez protesta, zajedno s mjeničnim očitovanjem, uz međusobni potpis zapisnika o primopredaji sredstava osiguranja.'
                                }
                            ]
                        },
                    ],
                    value: '',
                }
            ]
        },
        {
            title: 'RANIJE DOSPIJEĆE VRAĆANJA ZAJMA',
            mandatory: false,
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    editable: false,
                    parts: [
                        {
                            type: 'text',
                            content: 'Zajmodavac u svakom trenutku može učiniti zajam dospjelim pri čemu će Zajmoprimac biti dužan vratiti zajam u roku od'
                        },
                        {type: 'input', value: '', required: true},
                        {type: 'text', content: 'dana od obavijesti Zajmodavca.'}],
                }],
        },
        {
            title: 'POVRAT ZAJMA ',
            mandatory: false,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    editable: false,
                    choices: [
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Po dospijeću obveza povrata glavnice, Zajmoprimac će novčana sredstva doznačiti na račun Zajmodavca otvoren u'
                                },
                                {type: 'input', value: '', required: true,}, 
                                {type: 'text', content: 'd.d.,', help: 'Upišite naziv banke u kojoj Zajmodavac ima otvoren poslovni račun.'},
                                {type: 'text', content:  'IBAN broj:'},
                                {type: 'input', value: '', required: true},
                                {type: 'text', content: '.'}]
                        },
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Po dospijeću glavnice i kamata, Zajmoprimac će novčana sredstva doznačiti na račun Zajmodavca otvoren u'
                                },
                                {type: 'input', value: '', required: true,}, 
                                {type: 'text', content: 'd.d.,', help: 'Upišite naziv banke u kojoj Zajmodavac ima otvoren poslovni račun.'},
                                {type: 'text', content:  'IBAN broj:'},
                                {type: 'input', value: '', required: true},
                                {type: 'text', content: '.'}]
                        },
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Po dospijeću obveza povrata glavnice, Zajmoprimac će novčana sredstva vratiti Zajmodavcu primopredajom u gotovini.',
                                    help: 'Prema Zakonu o sprječavanju pranja novca i financiranju terorizma, pravna ili fizička osoba koja obavlja registriranu djelatnost u Republici Hrvatskoj ne smije primiti naplatu ili obaviti plaćanje u gotovini u vrijednosti od 75.000,00 kuna na više. Navedena naplata ili plaćanje u gotovini, mora se provesti uplatom ili prijenosom na transakcijski račun.'
                                }
                            ]
                        },
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Po dospijeću obveza povrata glavnice i kamate,  Zajmoprimac će novčana sredstva vratiti Zajmodavcu primopredajom u gotovini.',
                                    help: 'Prema Zakonu o sprječavanju pranja novca i financiranju terorizma, pravna ili fizička osoba koja obavlja registriranu djelatnost u Republici Hrvatskoj ne smije primiti naplatu ili obaviti plaćanje u gotovini u vrijednosti od 75.000,00 kuna na više. Navedena naplata ili plaćanje u gotovini, mora se provesti uplatom ili prijenosom na transakcijski račun.'
                                }
                            ]
                        }],
                    value: '',
                }
            ]
        },
        {
            title: 'NADLEŽNOST',
            mandatory: false,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    editable: false,
                    choices: [
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom za Zajmodavca.'
                                }
                            ]
                        },
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom za Zajmoprimca.'
                                }
                            ]
                        },
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom u'
                                },
                                {type: 'input', value: '',help: "Upišite mjesno nadležni sud. Npr. ...sudom u Zagrebu; ...sudom u Splitu i sl..", required: true},
                            ]
                        }
                    ],
                    value: '',
                }
            ]
        },
        {
            title: 'PRIMJENA UGOVORA',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    required: false,
                    mandatory: true,
                    editable: true,
                    content: 'Ugovor se primjenjuje od trenutka potpisa ugovornih strana.',
                    value: '',
                }],
        },
        {
            title: 'PRIMJERCI UGOVORA',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    required: false,
                    mandatory: true,
                    editable: true,
                    content: 'Ovaj Ugovor sastavljen je u 2 (dva) primjerka, od kojih svaka ugovorna strana zadržava po 1 (jedan) primjerak.',
                    value: '',
                }],
          },
        {
            mandatory: true,
            static: true,
            type: 2, // date and place
            statements: [
              {
                type: "input",
                mandatory: true,
                parts: [
                  {
                    type: "text",
                    content: "U"
                  },
                  {
                    type: "input",
                    value: "",
                    placeholder: "Upišite mjesto.",
                    required: true,
                  },
                  {
                    type: "text",
                    content: ", dana"
                  },
                  {
                    type: "date",
                    value: new Date(),
                    required: true
                  },
                  {
                    type: "text",
                    content: "godine."
                  }
                ]
              },
            ]
          },
        {
            mandatory: true,
            static: true,
            type: 3,  // signatures
            statements: [],
        },
    ],
};



// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/47_ugovor_o_zajmu_zajmoprimac_fizicka_osoba.ts